import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu, Phone, Instagram, MessageCircle } from "lucide-react";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Accueil", href: "#accueil" },
    { name: "Nos Créations", href: "#creations" },
    { name: "Tarifs", href: "#tarifs" },
    { name: "À Propos", href: "#apropos" },
    { name: "Contact", href: "#contact" },
  ];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-pink-100 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="/images/latest-logo.png" 
              alt="Sweets by Gem - Cake Designer" 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-smooth hover:bg-pink-50"
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>

          {/* Contact Actions */}
          <div className="hidden md:flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => window.open("https://wa.me/33753797698", "_blank")}
              className="border-primary text-primary hover:bg-primary hover:text-white"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
            <Button
              size="sm"
              onClick={() => scrollToSection("#contact")}
              className="gradient-primary text-white shadow-elegant"
            >
              <Phone className="w-4 h-4 mr-2" />
              Réserver
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                <div className="flex flex-col space-y-4 mt-8">
                  <div className="text-center mb-6">
                    <img 
                      src="/images/latest-logo.png" 
                      alt="Sweets by Gem - Cake Designer" 
                      className="h-10 w-auto mx-auto"
                    />
                  </div>
                  
                  {navItems.map((item) => (
                    <button
                      key={item.name}
                      onClick={() => scrollToSection(item.href)}
                      className="text-left text-gray-700 hover:text-primary px-4 py-3 rounded-md text-base font-medium transition-smooth hover:bg-pink-50 border-b border-pink-100"
                    >
                      {item.name}
                    </button>
                  ))}
                  
                  <div className="pt-6 space-y-3">
                    <Button
                      variant="outline"
                      className="w-full border-primary text-primary hover:bg-primary hover:text-white"
                      onClick={() => window.open("https://wa.me/33753797698", "_blank")}
                    >
                      <MessageCircle className="w-4 h-4 mr-2" />
                      WhatsApp
                    </Button>
                    <Button
                      className="w-full gradient-primary text-white shadow-elegant"
                      onClick={() => scrollToSection("#contact")}
                    >
                      <Phone className="w-4 h-4 mr-2" />
                      Réserver
                    </Button>
                    <Button
                      variant="ghost"
                      className="w-full text-accent hover:text-accent/80"
                      onClick={() => window.open("https://www.instagram.com/sweetsby_gem", "_blank")}
                    >
                      <Instagram className="w-4 h-4 mr-2" />
                      @sweetsby_gem
                    </Button>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;